<template>
  <div class="form-course-item">
    <div class="form-item-title">{{ column.label }}:</div>
    <textarea
      fixed
      :placeholder="column.placeholder ? column.placeholder : '请输入'"
      @blur="blur"
      v-model="value"
      type="textarea"
    />
  </div>
</template>

<script>
export default {
  props: ['column'],
  data() {
    return {
      value: ''
    }
  },
  watch: {
    value(val) {
      /* eslint-disable no-misleading-character-class */
      const emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\\A9|AE]\u3030|\uA9|\uAE|\u3030/gi
      this.value = val.replace(emojiReg, '')
    }
  },
  methods: {
    blur() {
      const obj = {[this.column.prop]: this.value}
      this.$store.commit('setReport', obj)
    }
  }
}
</script>
<style scoped>
textarea {
  width: 100%;
  border: none;
  outline: none;
}
</style>
